import type { CustomerDataWithStatus } from '@packages/shared/src/hooks/useCustomer/useCustomer';
import { InputIDs } from '../../types';
import { rot47 } from '../../../../utils/rot47';

export const getDefaultValues = (
  customer: CustomerDataWithStatus | undefined,
  token?: string,
  forceFrequency?: string,
) => ({
  [InputIDs.EMAIL]: token ? rot47(token) : customer?.email || '',
  [InputIDs.FREQUENCY]: forceFrequency || (token ? 'unsubscribe|99' : ''),
  [InputIDs.PAUSE]: '',
});
